import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "edit-or-delete-project-modal";

const keys = addTranslations(RESOURCE_NAME, {
    edit_project_modal_title: {
        en: "Edit project",
        fr: "Modifier le projet",
    },
    edit_project_modal_entity_label: {
        en: "Entity",
        fr: "Entité",
    },
    edit_project_modal_delete_project_section_title: {
        en: "Delete project",
        fr: "Supprimer le projet",
    },
    edit_project_modal_delete_project_section_description: {
        en: "This action will permanently delete all of your work on this project.",
        fr: "Cette action supprimera définitivement tout votre travail sur ce projet.",
    },
    edit_project_modal_confirm_button_label: {
        en: "Save",
        fr: "Enregistrer",
    },
    edit_project_modal_cancel_button_label: {
        en: "Cancel",
        fr: "Annuler",
    },
    edit_project_modal_name_placeholder: {
        en: "Project name",
        fr: "Nom du projet",
    },
    delete_project_modal_title: {
        en: "Delete project",
        fr: "Supprimer le projet",
    },
    delete_project_modal_description: {
        en: "You are about to delete all of your work on this project. This action can not be undone.",
        fr: "Vous êtes sur le point de supprimer tout votre travail sur ce projet. Cette action ne peut pas être annulée.",
    },
    delete_project_modal_cancel_button_label: {
        en: "Cancel",
        fr: "Annuler",
    },
    delete_project_modal_confirm_button_label: {
        en: "Delete",
        fr: "Supprimer",
    },
});

export function useEditOrDeleteProjectModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
